import { css } from '@fable/theme'
import { Link } from 'react-router-dom'
import { Button, Text } from '@fable/components'
import { Book } from '@fable/types'
import { useActions } from '../../../../../hooks/useActions'
import { FORM_TYPES } from '../../../../auth/constants'

import { routes } from '../../../routes'

interface Props {
  book: Book
  isAuthenticated: boolean
  openBook: () => void
}

const BookPrice: React.FC<Props> = ({ book, isAuthenticated, openBook }) => {
  const { openAuthModal } = useActions()
  const { can_purchase, isbn, is_free, price_usd } = book
  const path = `${routes.checkout}/${isbn}`
  const disable = !can_purchase ? 'disable' : ''
  const bookPrice = '$' + price_usd

  if (is_free) {
    const buttonTitle = 'Start reading'

    return (
      <Button
        secondary
        width="fit-content"
        className={css`
          padding: 0 12px;
          height: 27px;
        `}
        disabled={disable?.length > 0}
        onClick={(e) => {
          e.stopPropagation()
          isAuthenticated ? openBook() : openAuthModal(FORM_TYPES.SIGN_UP)
        }}
        label={buttonTitle}
      />
    )
  }

  const authButton = (
    <div
      className={`book-price button border mini action force-overflow ${disable}`}
      onClick={(e) => {
        e.stopPropagation()
        openAuthModal(FORM_TYPES.SIGN_IN, path)
      }}
    >
      <Text
        className={css`
          padding: 4px 0;
        `}
        type="link"
        sizing="L"
      >
        {bookPrice}
      </Text>
    </div>
  )

  return !isAuthenticated ? (
    authButton
  ) : (
    <Link
      className={`book-price button border mini action force-overflow ${disable}`}
      to={path}
      onClick={(e) => e.stopPropagation()}
    >
      <Text
        className={css`
          padding: 4px 0;
        `}
        type="link"
        sizing="L"
      >
        {bookPrice}
      </Text>
    </Link>
  )
}

export default BookPrice
